export default "__VITE_ASSET__19654e04__"